export default {
  computed: {
    currentUserId() {
      return this.$store.getters.getUser.id;
    },
  },
  methods: {
    watchCardLocal(cardId, isWatching) {
      this.$store.dispatch('localUpdateCardField', {
        cardId,
        fieldName: 'is_watching',
        fieldValue: isWatching,
      });
    },
    watchPageLocal(pageId, isWatching) {
      this.$store.dispatch('localUpdatePageProp', {
        pageId,
        propertyName: 'is_watching',
        value: isWatching,
      });
    },

    toggleWatch(isWatching, section, sectionId) {
      const subscribe = !isWatching;
      const success = subscribe ? 'subscribedToResourceUpdates' : 'unsubscribedFromResourceUpdates';
      const error = subscribe
        ? 'subscribingToResourceUpdatesFailed'
        : 'unsubscribingFromResourceUpdatesFailed';
      return this.$store.dispatch('watchResource', {
        resourceType: section,
        resourceId: sectionId,
        subscribe,
        message: {
          success,
          error,
        },
      });
    },
  },
};
